import { nullSafeGetOrElse } from '../utils/DataAccessUtils';

export const defensiveIsUserInternalSupplier = (currentUser) =>
	nullSafeGetOrElse('facility.status', currentUser, '') === 'private';
